module.exports = __webpack_public_path__ + "a18b741db63cef50a2567b31c5df4e42.png";